/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { IContentApiClient } from './contracts'
import { UserVote, IArticle, IArticleRating } from '../ContentStateManager/contracts'
import { injectable } from 'inversify'

@injectable()
export class MockContentApiClient implements IContentApiClient {
	article: IArticle
	rating: IArticleRating

	constructor() {
		this.article = { contentItemId: '1234567', path: 'esMD/Home/Index', displayText: 'AUTOMATE esMD Homepage', publishedUtc: new Date(), markup: '<p>AUTOMATE esMD is a greate product.</p>' } as IArticle
		this.rating = { contentItemId: '1234567', countLikes: 10, countDislikes: 2, vote: UserVote.none } as IArticleRating
	}

	getArticle(path: string): Promise<IArticle> {
		return new Promise<IArticle>(resolve => {
			resolve(this.article)
		})
	}

	getRating(contentItemId: string, userId: string): Promise<IArticleRating> {
		return new Promise<IArticleRating>(resolve => {
			resolve(this.rating)
		})
	}

	vote(contentItemId: string, userId: string, vote: UserVote): Promise<IArticleRating> {
		if (vote === UserVote.like) {
			this.rating.countLikes++
			this.rating.vote = UserVote.like
		} else if (vote === UserVote.dislike) {
			this.rating.countDislikes++
			this.rating.vote = UserVote.dislike
		}
		return new Promise<IArticleRating>(resolve => {
			resolve(this.rating)
		})
	}

	deleteVote(contentItemId: string, userId: string, vote: UserVote): Promise<IArticleRating> {
		this.rating.vote = UserVote.none
		if (vote === UserVote.like) {
			this.rating.countLikes--
		} else if (vote === UserVote.dislike) {
			this.rating.countDislikes--
		}
		return new Promise<IArticleRating>(resolve => {
			resolve(this.rating)
		})
	}

	changeVote(contentItemId: string, userId: string, vote: UserVote): Promise<IArticleRating> {
		if (vote === UserVote.like) {
			this.rating.countLikes++
			this.rating.countDislikes--
			this.rating.vote = UserVote.like
		} else if (vote === UserVote.dislike) {
			this.rating.countLikes--
			this.rating.countDislikes++
			this.rating.vote = UserVote.dislike
		}
		return new Promise<IArticleRating>(resolve => {
			resolve(this.rating)
		})
	}
}
